<template>
  <span :class="$country === 'ru' ? 'version-ru' : 'version'">
    {{ $country === 'ru' ? 'BETBOOM 3.0.7' : 'BetBoom 3.0.7' }}
  </span>
</template>

<script>
export default {
  name: 'Version',
};
</script>

<style scoped>
.version {
  right: 20px;
  bottom: 10px;
  color: #bd8500;
  position: absolute;
  font-size: 16px;
  font-weight: bold;
}

.version-ru {
  color: #131314;
  position: absolute;
  top: 1016px;
  right: -700px;
  font-family: 'ONY One', serif;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
}
</style>
